<template>
  <ProgressCircular v-if="loading" />
  <form v-else novalidate :disabled="disabled" @submit.prevent="() => {}">
    <v-row no-gutters justify="space-between">
      <v-col cols="7">
        <v-card max-width="1200px" flat color="transparent">
          <v-card-title>
            <FormHeader
              :loading="loading"
              :disabled="disabled"
              :link="'page-accounts'"
              :title="getTitle ? `${getTitle}` : `Создать пользователя`"
            />
          </v-card-title>
          <v-tabs v-model="activeTab">
            <v-tab v-for="tab in tabs" :key="tab.value" :disabled="tab.isDisabled">
              {{ tab.title }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <PageContent height="80">
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <span>Email пользователя*</span>
                        <v-text-field
                          id="email"
                          v-model="fields.email"
                          outlined
                          :value="fields.email"
                          :autofocus="!fields.email"
                          :error-messages="validationErrors.email"
                          :loading="loading"
                          :disabled="disabled"
                          @input="$v.fields.email.$touch()"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <span>Логин пользователя*</span>
                        <v-text-field
                          id="login"
                          v-model="fields.login"
                          outlined
                          :value="fields.login"
                          :autofocus="!fields.login"
                          :error-messages="validationErrors.login"
                          :loading="loading"
                          :disabled="disabled"
                          @input="$v.fields.login.$touch()"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <span>Телефон пользователя*</span>
                        <v-text-field
                          id="phone"
                          v-model="fields.phone"
                          outlined
                          v-phone:withEmail
                          :error-messages="validationErrors.phone"
                          :loading="loading"
                          :disabled="disabled"
                          @input="$v.fields.phone.$touch()"
                        />
                        <!-- <v-text-field
                          id="phone"
                          outlined
                          readonly
                          :value="returnUserPhoneFormat"
                          :loading="loading"
                          :disabled="disabled"
                        /> -->
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <span>Пароль</span>
                        <v-text-field
                          id="password"
                          name="password"
                          counter
                          outlined
                          autocomplete="new-password"
                          v-model="fields.password"
                          :loading="loading"
                          :disabled="disabled"
                          :append-icon="isPasswordShown ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="isPasswordShown ? 'text' : 'password'"
                          :hint="`Длина пароля должна быть не менее ${minPasswdLength} символов`"
                          :error-messages="validationErrors.password"
                          @click:append="isPasswordShown = !isPasswordShown"
                        />
                      </v-col>
                    </v-row>
                    <UserAccount v-if="!isNew && data" :loading="loading" :data="data" />
                  </v-container>
                </v-card-text>
              </PageContent>
            </v-tab-item>
            <v-tab-item>
              <PageContent>
                <v-card-text>
                  <v-row no-gutters align="center" v-for="role in roles" :key="role.id">
                    <v-checkbox
                      hide-details
                      dense
                      :label="role.name"
                      :loading="loading"
                      :disabled="disabled"
                      :input-value="roleIdList.includes(role.id)"
                      @change="updateRoleHandler(role.id, roleIdList.includes(role.id))"
                      @click.native.stop
                    />
                  </v-row>
                </v-card-text>
              </PageContent>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          v-if="isNew"
          ref="manageSidePanel"
          :isLocales="false"
          :is-new="isNew"
          :is-loading="loading"
          :is-submit-disabled="
            activeTab === tabs.findIndex(tab => tab.value === 'roles') || disabled
          "
          @cancel="$router.push({ name: 'page-accounts' })"
          @submit="submit"
        />
        <ManageSidePanel
          v-else-if="data"
          ref="manageSidePanel"
          :isLocales="false"
          :is-new="!data.id"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :is-submit-disabled="
            activeTab === tabs.findIndex(tab => tab.value === 'roles') || disabled
          "
          :entity-id="data.id"
          :entity-type="'account'"
          @delete="$emit('delete-account')"
          @cancel="$router.push({ name: 'page-accounts' })"
          @submit="submit"
        >
          <template #body>
            <v-card flat>
              <v-card-subtitle class="grey--text">Связи</v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        >Профили ({{ getCountProfiles }})</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <RelationComponent
                          :culturalOrganizations="getCulturalOrganizations"
                          :eventOrganizers="getEventOrganizers"
                          :guides="getGuides"
                          :hotels="getHotels"
                          :touristAgencies="getTouristAgencies"
                          :loading="loading"
                          :disabled="disabled"
                        />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
                <v-row>
                  <RelationsAccount
                    :profiles="profiles"
                    :sharedAccess="sharedAccess"
                    :reservations="reservations"
                    :ticketReservations="ticketReservations"
                    :loading="loading"
                    :disabled="disabled"
                  />
                </v-row>
              </v-card-text>
            </v-card>
          </template>
        </ManageSidePanel>
      </v-col>
    </v-row>
  </form>
</template>
<script>
import { phone } from '@/configs/directives'
import validationRules from './validation-rules.js'

import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel'
import UserAccount from '@/pages/account/user'
import pagesRoles from '@/services/gql/types/Roles/queries/roles.gql'
import FormHeader from '@/components/form-header'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'
import RelationsAccount from '../relations'
import RelationComponent from '@/components/relation-component'

export default {
  name: 'FormPageAccount',
  validationRules,
  directives: { phone },
  components: {
    PageContent,
    ManageSidePanel,
    UserAccount,
    FormHeader,
    ProgressCircular,
    RelationsAccount,
    RelationComponent
  },
  extends: FormAbstract,
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isNew: {
      type: Boolean,
      default: true
    },
    minPasswdLength: {
      type: Number,
      default: 6
    },
    profiles: {
      type: Object,
      default: () => null
    },
    sharedAccess: {
      type: Object,
      default: () => null
    },
    reservations: {
      type: Object,
      default: () => null
    },
    ticketReservations: {
      type: Object,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeTab: 0,
      fields: {
        email: null,
        phone: null,
        login: null,
        password: null,
        firstName: null,
        lastName: null,
        middleName: null,
        birthday: null,
        gender: null,
        avatarUrl: null,
        roles: null,
        favoriteEvents: null,
        favoritePlaces: null,
        favoriteRoutes: null,
        favoriteAudioguides: null
      },
      roles: [],
      chosenRoles: [],
      isPasswordShown: false
    }
  },
  computed: {
    tabs () {
      return [
        {
          title: 'Основное',
          value: 'main'
        },
        {
          title: 'Роли',
          value: 'roles',
          isDisabled: this.isNew
        }
      ]
    },
    roleIdList () {
      if (this.data.roles === undefined) {
        return []
      }
      return this.data.roles.map(p => p.id)
    },
    getTitle () {
      if (this.data?.email || this.data?.phone) {
        if (this.data?.firstName) {
          return `${this.data.firstName || 'Редактировать пользователя'}`
        }
        return 'Редактировать пользователя'
      }
      return null
    },
    validationRulesVars () {
      return {
        isNew: this.isNew
      }
    },
    getCulturalOrganizations () {
      return this.profiles?.culturalOrganizations.map(cultureOrganisation => ({
        ...cultureOrganisation,
        __typename: 'CulturalOrganization'
      }))
    },
    getEventOrganizers () {
      return this.profiles?.eventOrganizers.map(eventOrganizer => ({
        ...eventOrganizer,
        __typename: 'EventOrganizer'
      }))
    },
    getGuides () {
      return this.profiles?.guides.map(guide => ({
        ...guide,
        __typename: 'Guide'
      }))
    },
    getHotels () {
      return this.profiles?.hotels.map(hotel => ({
        ...hotel,
        __typename: 'Hotel'
      }))
    },
    getTouristAgencies () {
      return this.profiles?.touristAgencies.map(TouristAgency => ({
        ...TouristAgency,
        __typename: 'TouristAgency'
      }))
    },
    getCountProfiles () {
      return Number(
        (this.getCulturalOrganizations?.length || 0) +
          (this.getEventOrganizers?.length || 0) +
          (this.getGuides?.length || 0) +
          (this.getHotels?.length || 0)
      )
    }
  },
  watch: {
    data (data) {
      this.populate(data)
      if (data?.phone) {
        this.fields.phone = this.populatedPhone(this.data.phone)
      }
    }
  },
  methods: {
    populatedPhone (phone) {
      if (phone?.split('')?.length === 11) {
        const [first, ...other] = phone?.split('').map(el => Number(el))
        if (first === 7) {
          return `+${first} (${other[0]}${other[1]}${other[2]}) ${other[3]}${other[4]}${other[5]}-${other[6]}${other[6]}-${other[8]}${other[9]}`
        } else {
          return `+7 (${other[0]}${other[1]}${other[2]}) ${other[3]}${other[4]}${other[5]}-${other[6]}${other[6]}-${other[8]}${other[9]}`
        }
      }
      return phone || ''
    },
    updateRoleHandler (value, isActive) {
      const roles = {}
      const item = { id: value }
      isActive ? (roles.disconnect = item) : (roles.connect = item)
      this.$emit('submit', { roles })
    },
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      delete payload.roles

      payload.phone = this.preparedPhone(payload.phone)
      this.$emit('submit', {
        phone: payload.phone,
        email: payload.email,
        login: payload.login,
        password: payload.password
      })
    },
    preparedPhone (phone) {
      return phone.match(/\d+/g).join('')
    }
  },
  apollo: {
    roles: {
      query: pagesRoles,
      fetchPolicy: 'network-only',
      variables: {
        where: {}
      },
      result (res) {
        this.roles = res.data.roles.list
      }
    }
  }
}
</script>
